'use strict';
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
const react_1 = __importDefault(require('react'));
const form_1 = __importDefault(require('../contexts/form'));
const BasicForm_1 = __importDefault(require('./BasicForm'));
const PostForm_1 = __importDefault(require('./PostForm'));
function Form(props) {
  return react_1.default.createElement(
    form_1.default,
    { defaultData: props.defaultData },
    props.action
      ? react_1.default.createElement(
          PostForm_1.default,
          Object.assign({}, props)
        )
      : react_1.default.createElement(
          BasicForm_1.default,
          Object.assign({}, props)
        )
  );
}
exports.default = Form;
//# sourceMappingURL=Form.js.map
